import { Box } from '@mui/material';
import { useState } from 'react';
import UtilitiesApi from '../../../../../apis/UtilitiesApi';
import ConfirmDialog from '../../../../../components/ConfirmDialog/ConfirmDialog';
import { UtilitiesUserSearchDto } from '../../../../../generated-types/utilitiesUserSearchDto';
import useApi from '../../../../../lib/useApi';
import UserSearch from '../components/UserSearch';

/**
 * A utility that allows the admin to delete a user
 */
const DeleteUserUtility = () => {
  const [selectedUser, setSelectedUser] =
    useState<UtilitiesUserSearchDto | null>(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const utilitiesApi = useApi(UtilitiesApi);
  // Used to ensure the user search is updated
  const [deleteCount, setDeleteCount] = useState(0);

  return (
    <>
      <Box marginBottom={2}>
        <UserSearch
          key={deleteCount}
          onSelectedUser={(u) => {
            setSelectedUser(u);
            setShowConfirmDialog(true);
          }}
          selectedUser={selectedUser}
        />
      </Box>
      <ConfirmDialog
        dialogTitle="Confirm Deletion"
        dialogBody="Are you sure you want to delete the user? This cannot be undone."
        successMessage="Successfully deleted the user."
        errorMessage="An error occurred while trying to delete the user. Please try again."
        showDialog={showConfirmDialog}
        onClose={() => {
          setSelectedUser(null);
          setShowConfirmDialog(false);
        }}
        confirmText="Delete"
        confirmAction={async () => {
          await utilitiesApi.DeleteUser(selectedUser!.id);
          setDeleteCount((d) => d + 1);
        }}
        confirmColor="error"
      />
    </>
  );
};

export default DeleteUserUtility;
